import { Grid, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Project } from "../../../types/project";

type ProjectSavedPageProps = {
  project: Project | null;
};

export default function ProjectSavedPage({ project }: ProjectSavedPageProps) {
  const { t } = useTranslation();
  return (
    <Grid container>
      <Grid item xs />
      <Grid md={6} item>
        <Box>
          <Typography fontSize={30}>{t("projectSavedPage.text1")}</Typography>
        </Box>

        <Box mt={5}>
          <Typography>{t("projectSavedPage.text2")}</Typography>
        </Box>
        {!project?.skipLocalCoordinator && (
          <Box mt={5}>
            <Typography>{t("projectSavedPage.text3")}</Typography>
          </Box>
        )}
        <Box mt={5}>
          <Typography>{t("projectSavedPage.text4")}</Typography>
        </Box>
      </Grid>
      <Grid item xs />
    </Grid>
  );
}
